import React from 'react';
import './App.css';
import Login from "./Components/Auth/Login";
import { AuthProvider, useAuth } from "./Components/Auth/AuthContext";
import { NotificationProvider } from "./Components/Utils/NotificationContext";
import { AuthStage } from "./Components/Auth/types";
import AppInitializer from './Components/AppInitializer';
import AuthRedirect from './Components/Auth/AuthRedirect';
import Dashboard from "./Components/Dashboard/Dashboard";
import ReportNewSickLeave from "./Components/SickReport/ReportNewSickLeave";
import ClientStandIn from "./Components/ClientStandIn/ClientStandIn";
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { DataProvider } from './Components/Data/DataContext';
import EditSingleSickLeave from "./Components/SickReport/EditSingleSickLeave";

// Auth-Check-Komponente für geschützte Routen
const ProtectedRoute: React.FC<{children: React.ReactNode}> = ({ children }) => {
  const { authData } = useAuth();

  if (authData.isLoading) {
    return <div>Lade...</div>;
  }

  if (authData.stage !== AuthStage.AUTHENTICATED) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

// Prüft den Anmeldestatus und leitet weiter
const AuthCheck: React.FC = () => {
  const { authData } = useAuth();

  if (authData.isLoading) {
    return <div>Lade...</div>;
  }

  if (authData.stage === AuthStage.AUTHENTICATED) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Login />;
};

function App() {
  return (
    <DataProvider>
      <AuthProvider>
        <AppInitializer />
        <Router>
          <NotificationProvider>
            <AuthRedirect />
          <Routes>
            <Route path="/login" element={<AuthCheck />} />
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
            <Route path="/sick-leave/edit/:type/:id" element={
              <ProtectedRoute>
                <EditSingleSickLeave />
              </ProtectedRoute>
            } />
            <Route path="/sick-report/new" element={
              <ProtectedRoute>
                <ReportNewSickLeave/>
              </ProtectedRoute>
            } />
            <Route path="/standin" element={
              <ProtectedRoute>
                <ClientStandIn />
              </ProtectedRoute>
            } />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
          </NotificationProvider>
        </Router>
      </AuthProvider>
    </DataProvider>
  );
}

export default App;
